import { useTheme, IconButton } from "@mui/material";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";

export interface ImpersonationBannerProps {
  userEmail: string;
}

export default function ImpersonationBanner({
  userEmail,
}: ImpersonationBannerProps) {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="welcome-banner"
          exit={{ height: 0, transform: "translateY(-100%)" }}
          style={{
            overflow: "hidden",
            background: theme.palette.warning.main,
            color: "white",
            padding: "0.5em",
            fontSize: "85%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            You are currently logged in as&nbsp;<strong>{userEmail}</strong>.
          </div>
          <IconButton
            size="small"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            <CloseIcon
              fontSize="small"
              style={{
                color: "white",
              }}
            />
          </IconButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
